import React from 'react';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';

/* Este componente permite buscar en el catalogo de articulos, clasificando los articulos por el tipo: PRODUCTOS o SERVICIOS
*/

export default class SelectArticulo extends React.Component{        
    
    getOptions_ArticulosTipoProducto(input, callback){
        if (input.toString().length >= 3 ){
            let query = '?tipo=catalogo&status=A&cadena_busq=' + input + '&tipo_articulos=P';
            cargarCatalogosGenericoAsync('/articulos', query, callback)
        }
    }

    getOptions_ArticulosTipoServicio(input, callback){
        if (input.toString().length >= 3 ){
            let query = '?tipo=catalogo&status=A&cadena_busq=' + input + '&tipo_articulos=S';
            cargarCatalogosGenericoAsync('/articulos', query, callback)
        }
    }

    render(){
        return(
            <ReactSelectAsync func_ref={this.props.func_ref} value={this.props.value} func_loadOptions={this.props.tipoArticulos==='S'? this.getOptions_ArticulosTipoServicio: this.getOptions_ArticulosTipoProducto} func_onChange={this.props.func_onChange}/>
        )
    }
}